import { Reducer } from 'interfaces'
import { VideoCallsAppState, LocalStreamState } from 'components/features/videoCalls/types/state'
import {
  AgoraPublishLocalStream,
  AgoraUnPublishLocalStream,
  AgoraJoinChannelAction,
  AgoraMuteAudioAction,
  AgoraUnmuteAudioAction,
  AgoraMuteVideoAction,
  AgoraUnmuteVideoAction,
  AgoraAudioInputAction,
  AgoraVideoInputAction,
  AgoraClientEventAction,
} from 'components/features/videoCalls/types/actions'

export const localStreamReducer: Reducer<VideoCallsAppState['localStream']> = (prevState = new LocalStreamState(), action) => {
  switch (action.type) {
    case AgoraPublishLocalStream.type: {
      if (action.meta === 'request') {
        return {
          ...prevState,
          state: 'progress',
        }
      }

      if (action.meta === 'fail') {
        return {
          ...prevState,
          state: 'idle',
        }
      }

      const { audioInputDeviceId, videoInputDeviceId } = action.payload.response
      return {
        ...prevState,
        state: 'active',
        audioInputDeviceId,
        videoInputDeviceId,
      }
    }

    case AgoraUnPublishLocalStream.type: {
      if (action.meta === 'request') {
        return {
          ...prevState,
          state: 'progress',
        }
      }

      if (action.meta === 'success') {
        return {
          ...prevState,
          state: 'idle',
        }
      }

      return prevState
    }

    case AgoraJoinChannelAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      const { localStreamId } = action.payload.response
      return {
        ...prevState,
        streamId: localStreamId,
      }
    }

    case AgoraMuteAudioAction.type: {
      if (action.meta === 'request') {
        return {
          ...prevState,
          audioMuteState: 'muting',
        }
      }
      if (action.meta === 'fail') {
        return {
          ...prevState,
          audioMuteState: 'unmute',
        }
      }
      return {
        ...prevState,
        audioMuteState: 'mute',
      }
    }

    case AgoraUnmuteAudioAction.type: {
      if (action.meta === 'request') {
        return {
          ...prevState,
          audioMuteState: 'unmuting',
        }
      }
      if (action.meta === 'fail') {
        return {
          ...prevState,
          audioMuteState: 'mute',
        }
      }
      return {
        ...prevState,
        audioMuteState: 'unmute',
      }
    }

    case AgoraMuteVideoAction.type: {
      if (action.meta === 'request') {
        return {
          ...prevState,
          videoMuteState: 'muting',
        }
      }
      if (action.meta === 'fail') {
        return {
          ...prevState,
          videoMuteState: 'unmute',
        }
      }
      return {
        ...prevState,
        videoMuteState: 'mute',
      }
    }

    case AgoraUnmuteVideoAction.type: {
      if (action.meta === 'request') {
        return {
          ...prevState,
          videoMuteState: 'unmuting',
        }
      }
      if (action.meta === 'fail') {
        return {
          ...prevState,
          videoMuteState: 'mute',
        }
      }
      return {
        ...prevState,
        videoMuteState: 'unmute',
      }
    }

    case AgoraAudioInputAction.type: {
      return {
        ...prevState,
        audioInputDeviceId: action.payload,
      }
    }

    case AgoraVideoInputAction.type: {
      return {
        ...prevState,
        videoInputDeviceId: action.payload,
      }
    }

    case AgoraClientEventAction.type: {
      const event = action.payload
      switch (event.type) {
        case 'recording-device-changed': {
          if (event.state === 'INACTIVE') {
            return {
              ...prevState,
              audioInputDeviceId: null,
            }
          }

          if (event.state === 'ACTIVE') {
            return {
              ...prevState,
              audioInputDeviceId: event.device.deviceId,
            }
          }

          return prevState
        }
      }
    }

  }
  return prevState
}
